import { render, staticRenderFns } from "./routerHolder.vue?vue&type=template&id=a1f32114&"
import script from "./routerHolder.vue?vue&type=script&lang=js&"
export * from "./routerHolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1f32114')) {
      api.createRecord('a1f32114', component.options)
    } else {
      api.reload('a1f32114', component.options)
    }
    module.hot.accept("./routerHolder.vue?vue&type=template&id=a1f32114&", function () {
      api.rerender('a1f32114', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/routerHolder.vue"
export default component.exports